import {
    ORDER_GRID_DATA,
    ORDER_GRID_ERROR,
    ORDER_GRID_LOADING,
    ORDER_GRID_PAGE_CHANGE,
    ORDER_GRID_STATE_CHANGE,
} from "../constants";
import { generateReducer } from "../../common/helpers";

const initialState = {
    error: null,
    orders: [],
    isLoading: false,
    currentPage: 1,
    lastRow: null,
    pageSize: 25,
    sortModel: [
        {
            colId: "created_at",
            sort: "desc",
        },
    ],
    filterModel: {},
};

const setGridData = (state, { orders, lastRow }) => ({
    ...state,
    error: null,
    isLoading: false,
    lastRow,
    orders,
});

const changeGridPage = (state, currentPage) => ({ ...state, currentPage });
const changeGridState = (state, payload) => ({ ...state, ...payload });
const setGridLoading = state => ({ ...state, isLoading: true });
const setGridError = (state, error) => ({ ...state, isLoading: false, error });

const reducers = {
    [ORDER_GRID_DATA]: setGridData,
    [ORDER_GRID_ERROR]: setGridError,
    [ORDER_GRID_LOADING]: setGridLoading,

    [ORDER_GRID_PAGE_CHANGE]: changeGridPage,
    [ORDER_GRID_STATE_CHANGE]: changeGridState,
};

export default generateReducer(reducers, initialState);
